export default __webpack_public_path__ + "static/media/growth_advisory_section.e5c6f3df.jpg";